import { Alert, Button, Empty, Table } from "antd";

// ux2(D/shared): consistent loading / error / empty treatment for list
// tables. Pass-through wrapper over antd's own <Table> -- every prop Table
// accepts still works (locale, custom loading objects, components, etc. via
// ...rest); this only adds:
//   - `error` (string|null): when set, the table body is replaced by an
//     Alert with a Retry button instead of rendering rows.
//   - `onRetry`: called by the Alert's Retry button.
//   - `emptyText`: fills antd's `locale.emptyText` with an <Empty/> when the
//     caller has not already supplied its own `locale` (a caller's own
//     `locale` -- e.g. a round-1 A3 hint -- is passed straight through as-is
//     and takes precedence).
// `loading` is passed straight to Table, unchanged from today's behaviour.
const ListTable = ({ error, onRetry, emptyText, locale, ...rest }) => {
  if (error) {
    return (
      <Alert
        type="error"
        showIcon
        message={error}
        action={
          onRetry ? (
            <Button size="small" onClick={onRetry}>
              Retry
            </Button>
          ) : undefined
        }
      />
    );
  }

  const resolvedLocale = locale || {
    emptyText: <Empty description={emptyText || "No records to show yet."} />,
  };

  return <Table locale={resolvedLocale} {...rest} />;
};

export default ListTable;
